import clsx from 'clsx';

import { FieldWrapper } from './FieldWrapper';

export const RegularTextAreaField = (props) => {
  const {
    rows = 3,
    label,
    className,
    disabled,
    value,
    registration,
    caption,
    placeholder,
    onChange,
    error,
    maxLength,
  } = props;

  return (
    <FieldWrapper label={label} error={error}>
      <textarea
        id="message"
        rows={rows}
        className={clsx(
          'block p-2.5 w-full text-sm rounded-2xl bg-white/10 dark:bg-white/10 border border-white/20 dark:border-white/10 backdrop-blur-sm focus:ring-cyan-400 focus:border-cyan-400 text-white placeholder-gray-400 outline-none',
          className
        )}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        value={value}
        {...registration}
        onChange={onChange}
      ></textarea>
      <div className="my-1 text-xs flex justify-end">{caption}</div>
    </FieldWrapper>
  );
};
